"use strict";

var React = require('react');

var startCase = require('lodash/startCase');

var PropTypes = require('prop-types');

var moment = require('moment');

var ProductDetailsWrapper = require('../components/ProductDetailsWrapper');

var Space = require('../components/Space');

var HorizontalLine = require('../components/HorizontalLine');

var PrintJobPaperTypes = require('../components/PrintJobPaperTypes');

var PrintJobColorsUsed = require('../components/PrintJobColorsUsed');

var PrintJobDesignNames = require('../components/PrintJobDesignNames');

var PaperComponentDetails = require('../components/PaperComponentDetails');

var EnvelopeComponentDetails = require('../components/EnvelopeComponentDetails');

var RibbonSpoolDetails = require('../components/RibbonSpoolDetails');

var WaxSealDetails = require('../components/WaxSealDetails');

var VellumJacketDetails = require('../components/VellumJacketDetails');

var GlueDotsDetails = require('../components/GlueDotsDetails');

var Highlight = require('../components/Highlight');

var _require = require('../../helpers'),
    isEnvelope = _require.isEnvelope,
    isPaperComponent = _require.isPaperComponent,
    isLetterpressComponent = _require.isLetterpressComponent,
    isRibbon = _require.isRibbon;

var digitalPaperComponents = function digitalPaperComponents(c) {
  return isPaperComponent(c) && !isEnvelope(c) && !isLetterpressComponent(c);
};

function SampleSets(props) {
  var PrintJobs = props.PrintJobs,
      user = props.user,
      options = props.options;

  if (PrintJobs.length > 1) {
    throw new Error('SampleSets template is meant for 1 print job');
  }

  var printJob = PrintJobs[0];
  var printer = 'printingPlus';
  var componentSettings = options.printers[printer].components;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PrintJobPaperTypes, {
    variant: "digital",
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement("span", null, "Sent by: ", startCase(user.displayName)), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement("span", null, "Customer Approval Date: ", moment(printJob.approved_on_date).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement("span", null, "Ship by Date: ", moment(printJob.print_by_date).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(PrintJobPaperTypes, {
    variant: "digital",
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(PrintJobColorsUsed, {
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(PrintJobDesignNames, {
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), !printJob.is_reprint && /*#__PURE__*/React.createElement(React.Fragment, null, printJob.notes.map(function (_ref, index) {
    var text = _ref.text;
    return /*#__PURE__*/React.createElement(Highlight, {
      key: index
    }, "Printer Note: ", text, /*#__PURE__*/React.createElement("br", null));
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
    printJob: printJob,
    filterFunction: isRibbon,
    RenderComponent: RibbonSpoolDetails,
    options: options,
    componentSettings: componentSettings,
    printer: printer
  }), /*#__PURE__*/React.createElement(WaxSealDetails, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    products: printJob.products
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(VellumJacketDetails, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    products: printJob.products
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(GlueDotsDetails, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    products: printJob.products
  }, /*#__PURE__*/React.createElement(Space, {
    n: 2
  })), /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
    printJob: printJob,
    filterFunction: digitalPaperComponents,
    RenderComponent: PaperComponentDetails,
    options: options,
    componentSettings: componentSettings,
    printer: printer
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
    printJob: printJob,
    filterFunction: isEnvelope,
    RenderComponent: EnvelopeComponentDetails,
    options: options,
    componentSettings: componentSettings,
    printer: printer
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement("span", null, "Estimated Pricing"), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement("span", null, "Negotiated Pricing: 1350.00 + 0.00 = 1350.00", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("span", null, "TOTAL PRICE: 1350.00", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }));
}

SampleSets.defaultProps = {};
SampleSets.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  Shipments: PropTypes.array.isRequired,
  user: PropTypes.shape({
    displayName: PropTypes.string.isRequired
  }).isRequired,
  options: PropTypes.object
};
module.exports = SampleSets;